<template>
  <ul class="halo-tree">
      <li v-for="(item, index) in data"@drop="drop(item, $event)" @dragover="dragover($event)" :key="item.title" :class="{leaf: isLeaf(item), 'first-node': !parent && index === 0, 'only-node': !parent && data.length === 1}"  v-show="item.hasOwnProperty('visible') ? item.visible : true">
          <div class="tree-node-el" :draggable="draggable" @dragstart="drag(item, $event)">
              <span @click="expandNode(item)" v-if="item.children && item.children.length > 0" :class="item.expanded ? 'tree-open' : 'tree-close'">
              </span>
              <div v-if='multiple' :class="[item.checked ? (item.halfcheck ? 'box-halfchecked' : 'box-checked') : 'box-unchecked', 'inputCheck']">
                  <input class="check" v-if='multiple' type="checkbox" @change="changeCheckStatus(item, $event)" v-model="item.checked"/>
              </div>
              <Render :node="item" :tpl ='tpl'/>
              {{item.level}}
          </div>
          <transition name="bounce">
            <tree v-if="!isLeaf(item)" :dragAfterExpanded="dragAfterExpanded" :draggable="draggable" v-show="item.expanded"  :tpl ="tpl" :data="item.children" :halfcheck='halfcheck' :scoped='scoped' :parent ='item' :multiple="multiple"></tree>
          </transition>
      </li>
  </ul>
</template>
<script>
import Render from './render'
import mixins from './mixins'
export default {
  name: 'Tree',
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    parent: {
      type: Object,
      default: () => null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dragAfterExpanded: {
      type: Boolean,
      default: true
    },
    halfcheck: {
      type: Boolean,
      default: false
    },
    scoped: {
      type: Boolean,
      default: false
    },
    tpl: Function
  },
  components: { Render },
  watch: {
    data () {
      this.initHandle()
    }
  },
  mounted () {
    /*
     * @event monitor the children nodes seleted event
     */
    this.$on('childSelected', (node, checked) => {
      if (node.children && node.children.length) {
        for (let child of node.children) {
          this.$set(child, 'checked', checked)
          this.$emit('nodeSelected', child, checked)
        }
      }
    })

    /*
     * @event monitor the parent nodes seleted event
     */
    this.$on('parentSeleted', (node, checked) => {
      this.$set(node, 'checked', checked)
      if (!node.parent) return false
      let someBortherNodeChecked = node.parent.children.some(node => node.checked)
      let allBortherNodeChecked = node.parent.children.every(node => node.checked)
      if (this.halfcheck) {
        // all / some / none
        allBortherNodeChecked ? this.$set(node.parent, 'halfcheck', false) : someBortherNodeChecked ? this.$set(node.parent, 'halfcheck', true) : this.$set(node.parent, 'halfcheck', false)
        if (!checked && someBortherNodeChecked) {
          this.$set(node.parent, 'halfcheck', true)
          return false
        }
        this.$emit('parentSeleted', node.parent, checked)
      } else {
        if (checked && allBortherNodeChecked) this.$emit('parentSeleted', node.parent, checked)
        if (!checked) this.$emit('parentSeleted', node.parent, checked)
      }
    })

    /*
     * @event monitor the node seleted event
     */
    this.$on('nodeSelected', (node, checked) => {
      if (!this.scoped) {
        this.$emit('parentSeleted', node, checked)
        this.$emit('childSelected', node, checked)
      } else {
        this.$set(node, 'checked', checked)
      }
    })

     /*
     * @event monitor the node visible event
     */
    this.$on('toggleshow', (node, isShow) => {
      this.$set(node, 'visible', isShow)
      if (isShow && node.parent) {
        this.$emit('toggleshow', node.parent, isShow)
      }
    })

    this.$on('cancelSelected', (root) => {
      for (let child of root.$children) {
        for (let node of child.data) {
          child.$set(node, 'selected', false)
        }
        if (child.$children) child.$emit('cancelSelected', child)
      }
    })
    this.initHandle()
  },
  methods: {
    drop (node, ev) {
      ev.preventDefault()
      ev.stopPropagation()
      let guid = ev.dataTransfer.getData('guid')
      let drag = this.getDragNode(guid)
      // if drag node's parent is enter node or root node
      if (drag.parent === node || drag.parent === null) return false
      // drag from parent node to child node
      if (this.hasInGenerations(drag, node)) return false
      let dragHost = drag.parent.children
      if (node.children && node.children.indexOf(drag) === -1) {
        node.children.push(drag)
        dragHost.splice(dragHost.indexOf(drag), 1)
      } else {
        this.$set(node, 'children', [drag])
        dragHost.splice(dragHost.indexOf(drag), 1)
      }
      this.$set(node, 'expanded', this.dragAfterExpanded)
    },
    drag (node, ev) {
      let guid = this.guid()
      this.setDragNode(guid, node)
      ev.dataTransfer.setData('guid', guid)
    },
    dragover (ev) {
      ev.preventDefault()
      ev.stopPropagation()
    },
    /*
    * @method dynamically add an 'parent' attribute for every node
    */
    initHandle () {
      for (let node of this.data) {
        this.$set(node, 'parent', this.parent)
      }
    },
    /* @method expand or close node
     * @param node current node
    */
    expandNode (node) {
      this.$set(node, 'expanded', !node.expanded)
    },
    /* @method Determine whether it is a leaf node
     * @param node current node
    */
    isLeaf (node) {
      return !(node.children && node.children.length)
    },
    /* @method adding child node
     * @param node parent node
     * @param newnode  new node
    */
    addNode (parent, newNode) {
      this.$set(parent, 'expanded', true)
      let addnode = null
      if (typeof newNode === 'undefined') {
        throw new ReferenceError('newNode is required but undefined')
      }
      if (typeof newNode === 'string') {
        addnode = {title: newNode}
      } else {
        if (newNode && !newNode.hasOwnProperty('title')) {
          throw new ReferenceError('the property (title) is missed')
        }
        addnode = newNode
      }
      if (this.isLeaf(parent)) {
        this.$set(parent, 'children', [])
        parent.children.push(addnode)
      } else {
        parent.children.push(addnode)
      }
      this.$emit('addNode', { parentNode: parent, newNode: newNode })
    },
    /* @method adding childlren nodes
     * @param node parent node
     * @param newnode  new node
    */
    addNodes (node, children) {
      for (let n of children) {
        this.addNode(node, n)
      }
    },
    /* @method delete a node
     * @param  parent parent node
     * @param  node current node
     */
    delNode (parent, node) {
      if (parent === null || typeof parent === 'undefined') {
        throw new ReferenceError('the root element can\'t deleted!')
      }
      parent.children.splice(parent.children.indexOf(node), 1)
      this.$emit('delNode', { parentNode: parent, delNode: node })
    },
    /*
     *@method change the check box status method
     *@param node current node
     *@param $event event object
     */
    changeCheckStatus (node, $event) {
      this.$emit('nodeSelected', node, $event.target.checked)
    },

      /*
     *@method change the node selected  method
     *@param node current node
     */
    nodeSelected (node) {
      const getRoot = (el) => {
        if (el.$parent.$el.nodeName === 'UL') {
          el = el.$parent
          return getRoot(el)
        } return el
      }
      let root = getRoot(this)
      if (!this.multiple) {
        for (let rn of root.data) this.$set(rn, 'selected', false)
        this.$emit('cancelSelected', root)
      }
      if (this.multiple) this.$set(node, 'checked', !node.selected)
      this.$set(node, 'selected', !node.selected)
    },

    /*
     *@method get Nodes by options method
     *@param data nodes
     *@param opt the options that filter the node
     */
    getNodes (data, opt) {
      data = data || this.data
      let res = []
      for (const node of data) {
        let tmp = true
        for (const [key, value] of Object.entries(opt)) {
          if (node[key] !== value) {
            tmp = false
            break
          }
        }
        if (tmp) res.push(node)
        if (node.children && node.children.length) {
          res = res.concat(this.getNodes(node.children, opt))
        }
      }
      return res
    },

     /*
     *@method get Nodes that selected
     */
    getSelectedNodes () {
      return this.getNodes(this.data, {selected: true})
    },

    /*
     *@method get Nodes that checked
     */
    getCheckedNodes () {
      return this.getNodes(this.data, {selected: true})
    },

      /*
     *@method search nessary nodes methods
     *@param customFilter string or predicate expression
     *@param data current nodes
     */
    searchNodes (customFilter, data) {
      data = data || this.data
      for (const node of data) {
        let searched = customFilter ? (typeof customFilter === 'function' ? customFilter(node) : node.title.indexOf(customFilter) > -1) : false
        this.$set(node, 'searched', searched)
        this.$set(node, 'visible', false)
        this.$emit('toggleshow', node, customFilter ? searched : true)
        if (node.children && node.children.length) {
          if (searched) this.$set(node, 'expanded', true)
          this.searchNodes(customFilter, node.children)
        }
      }
    }
  }
}
</script>
<style>
    .halo-tree .bounce-enter-active {
        animation:bounce-in .5s;
    }
    .halo-tree .bounce-leave-active {
        animation:bounce-in .5s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform:scale(0);
        }
        50% {
            transform:scale(1.5);
        }
        100% {
            transform:scale(1);
        }
    }
    .halo-tree .expand-enter-active {
        transition:all 3s ease;
        height:50px;
        overflow:hidden;
    }
    .halo-tree .expand-leave-active {
        transition:all 3s ease;
        height:0px;
        overflow:hidden;
    }
    .halo-tree .expand-enter, .halo-tree .expand-leave {
        height:0;
        opacity:0;
    }
    .halo-tree {
        font-size:14px;
    }
    .halo-tree ul,.halo-tree li {
        list-style-type:none;
        text-align:left;
    }
    .halo-tree .inputCheck {
        display:inline-block;
        position:relative;
        width:14px;
        height:14px;
        border:1px solid #888888;
        border-radius:2px;
        top:4px;
        text-align:center;
        font-size:14px;
        line-height:14px;
    }
    .halo-tree .inputCheck.notAllNodes:before {
        content:"\2713";
        display:block;
        position:absolute;
        width:100%;
        height:100%;
        background-color:#888888;
        z-index:1;
        color:#ffffff;
    }
    .halo-tree .inputCheck.box-checked:after {
        content:"\2713";
        display:block;
        position:absolute;
        z-index:1;
        width:100%;
        text-align:center;
    }
    .halo-tree .box-halfchecked {
        background-color: #888888;
    }
    .halo-tree .box-halfchecked:after {
        content:"\2713";
        display:block;
        position:absolute;
        z-index:1;
        width:100%;
        text-align:center;
        color: #FFFFFF;
    }
    .halo-tree .check{
        display:block;
        position:absolute;
        font-size:14px;
        width:16px;
        height:16px;
        left:-5px;
        top:-4px;
        border:1px solid #000000;
        opacity:0;
        cursor:pointer;
        -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        filter:alpha(opacity=0);
        z-index:2;
    }
    .halo-tree li {
        margin: 0;
        padding: 5px 5px 5px 0;
        position: relative;
        list-style: none;
    }
    .halo-tree li:after,
    .halo-tree li:before {
        content: '';
        left: -8px;
        position: absolute;
        right: auto;
        border-width: 1px
    }
    .halo-tree li:before {
        border-left: 1px dashed #999;
        bottom: 50px;
        height: 100%;
        top: -8px;
        width: 1px;
    }

    .halo-tree li:after {
        border-top: 1px dashed #999;
        height: 20px;
        top: 17px;
        width: 12px
    }
    .halo-tree li:last-child::before {
        height: 26px
    }
    .halo-tree>li.first-node:before {
        border-left: none;
    }
    .halo-tree>li.only-node:after {
        border-top: none;
    }
    .halo-tree > ul {
        padding-left: 0
    }

    .halo-tree ul {
        padding-left: 17px;
        padding-top: 10px;
    }
    .halo-tree .tree-open,
    .halo-tree .tree-close {
        display: inline-block;
        width:14px;
        height:14px;
        text-align: center;
        line-height: 13px;
        border: 1px solid #888888;
        border-radius: 2px;
        background: #FFFFFF;
    }
    .halo-tree .tree-open {
        line-height: 13px;
    }
    .halo-tree .tree-close:after {
        content: "+";
        font-style: normal;
    }
    .halo-tree .tree-open:after {
        content: "\2013";
        font-style: normal;
    }
    .halo-tree .tree-node-el {
        background-color: #FFFFFF;
        padding-left: 2px;
        position: relative;
        z-index: 3;
    }
    .halo-tree li.leaf {
        padding-left: 19px;
    }

    .halo-tree li.leaf:after {
        content: '';
        left: -7px;
        position: absolute;
        right: auto;
        border-width: 1px;
        border-top: 1px dashed #999;
        height: 20px;
        top: 17px;
        width: 25px;
    }

    /*Dynamic style part*/
    .halo-tree-search-box {
        height: 18px;
        line-height: 18px;
        outline: none;
        border: 1px solid #888888;
        border-radius: 3px;
    }
    .halo-tree-search-box:focus {
        border: 1px solid rgb(16, 142, 233);
        -webkit-box-shadow: 0 2px 2px rgba(16, 142, 233, .2);
        box-shadow: 0 2px 2px rgba(16, 142, 233,.2);
        -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    }
    .halo-tree .node-title {
        padding: 3px 3px;
        border: 1px solid #FFFFFF;
        border-radius: 3px;
        cursor: pointer;
        margin: 0 2px;
    }
    .halo-tree .node-selected {
        border: 1px solid #DDDDDD;
        background-color: #DDDDDD;
    }
    .halo-tree .node-title.node-searched {
        border: 1px solid #FF8247;
    }
</style>


// WEBPACK FOOTER //
// src/lib/tree.vue